import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker, Icon, Button } from 'antd';
import { debounce } from 'lodash';

class YearPicker extends Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    defaultValue: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  };

  static defaultProps = {
    className: '',
    label: '',
    disabled: false,
    todayButtonId: '',
    onChange: () => {}
  };

  constructor(props) {
    super(props);

    this.state = {
      date: props.defaultValue || moment(), // Default to current year
      mode: 'year', // Force the mode to 'year'
      open: false // Control the dropdown state
    };
  }

  // Move to the previous year
  handleOnPreviousYearClick = () => {
    const { date } = this.state;
    const newDate = date.subtract(1, 'year').startOf('year');
    this.handleOnYearChange(newDate);
  };

  // Move to the next year
  handleOnNextYearClick = () => {
    const { date } = this.state;
    const newDate = date.add(1, 'year').startOf('year');
    this.handleOnYearChange(newDate);
  };

  // Set to the current year
  handleOnTodayClick = () => {
    const newDate = moment().startOf('year');
    this.handleOnYearChange(newDate);
  };

  // Handle year change
  handleOnYearChange = date => {
    this.setState({
      date,
      open: false // Close the picker after selecting a year
    });
    this.onDateChange(date);
  };

  // Handle the panel change to prevent mode switching and close the picker on year select
  handlePanelChange = (date, mode) => {
    if (mode === 'date') {
      // Prevent switching to the date panel and close the picker
      this.setState({ mode: 'year', open: false });
    } else {
      this.handleOnYearChange(date);
    }
  };

  componentDidUpdate(prevProp) {
    if (this.props.defaultValue !== prevProp.defaultValue) {
      this.setState({ date: this.props.defaultValue });
    }
  }

  // Debounce the change event to avoid firing too many times
  onDateChange = debounce(date => {
    const { onChange } = this.props;
    onChange(date);
  }, 300);

  // Handle opening and closing the picker
  handleOpenChange = status => {
    this.setState({ open: status });
  };

  render() {
    const { date, mode, open } = this.state;
    const { className, label, disabled, todayButtonId } = this.props;

    return (
      <div className={className}>
        {label && <label className="el-pageTitle">{label} </label>}

        <Button disabled={disabled} onClick={this.handleOnPreviousYearClick}>
          <Icon type="backward" />
        </Button>

        <DatePicker
          picker="year" // Ensure only year picker is used
          mode={mode} // Keep the mode in 'year'
          allowClear={false}
          value={date}
          open={open} // Control dropdown visibility
          onPanelChange={this.handlePanelChange} // Capture year selection and prevent mode switch
          onChange={this.handleOnYearChange}
          onOpenChange={this.handleOpenChange} // Open and close behavior
          placeholder="Select year"
          disabled={disabled}
          format="YYYY"
        />

        <Button disabled={disabled} onClick={this.handleOnNextYearClick}>
          <Icon type="forward" />
        </Button>

        <Button id={todayButtonId} disabled={disabled} type="secondary" onClick={this.handleOnTodayClick}>
          Today
        </Button>
      </div>
    );
  }
}

export default YearPicker;
